import { createChildListViewContainer } from 'factories/ChildListView'
import actions from 'actions/orders/orderItems'
import Component from 'components/Issue/Items'

export default createChildListViewContainer({
  actions,
  extraStateToProps: (state, props) => ({ settingsType: props.settingsType ?? 'issue' }),
})(Component)
